<inm-panel [ngClass]="isEditing ? 'inm-panel--no-padding' : ''">
  @if (isEditing && !reviewMode) {
    <div class="row partnerName">
      <div class="inm-subheading inm-mid-blue-text ps-4 col-4 mt-auto">
        {{ '.ar_account' | staticContent }}
      </div>
      <div class="col-8  partnerName-code">
        @if (accountPartner?.postingAccount) {
          <div>
            {{ accountPartner.postingAccount }}
            <div class="partnerName-name" inmOverflowTooltip placement="top">
              {{ accountPartner.postingAccountName || '-' }}
            </div>
          </div>
        } @else {
          {{ '-' }}
        }
      </div>
    </div>
  }
  <form role="form" [formGroup]="assignAccountDealersFormGroup">
    @if (!isEditing) {
      <inm-panel>
        <h5>
          {{ '.title' | staticContent }}
        </h5>
      </inm-panel>
    }
    <ng-container>
      <inm-input-container>
        <div class="row inline-edit-form">
          <div class="inm-subheading inm-mid-blue-text" [ngClass]="isEditing ? 'col-md-4 mt-auto' : ''">
            {{ '.contract_partner' | staticContent }}
          </div>
          @if (!accountDetails || accountDetails.accountGroup !== 'INMA') {
            <inm-search-box
              [ngClass]="isEditing ? 'col-md-8' : ''"
              formControlName="contractParty"
              [placeholder]="'.contract_partner' | staticContent"
              [results]="contractPartnerList"
              labelKey="accountDetail"
              valueKey="accountNumber"
              (search)="searchContractPartner($event)"
              [multiple]="false"
              >
            </inm-search-box>
            @if (contractPartnerCtrl.invalid && (contractPartnerCtrl.dirty || contractPartnerCtrl.touched)) {
              <inm-validation-message
                [ngClass]="isEditing ? 'col-md-8  offset-md-4' : ''"
                [control]="contractPartnerCtrl"
                [label]="'.contract_partner' | staticContent"
                >
              </inm-validation-message>
            }
          } @else {
            <div class="col-md-3 offset-md-4">
              -
            </div>
          }
        </div>
      </inm-input-container>
    </ng-container>
    <ng-container>
      <inm-input-container>
        <div class="row inline-edit-form">
          <div class="inm-subheading inm-mid-blue-text" [ngClass]="isEditing ? 'col-md-4 mt-auto' : ''">
            {{ '.management_company' | staticContent }}
          </div>
          @if (!accountDetails || accountDetails.accountGroup !== 'INMA') {
            <inm-search-box
              [ngClass]="isEditing ? 'col-md-8' : ''"
              formControlName="managementParty"
              [placeholder]="'.management_company' | staticContent"
              [results]="managementCompanyList"
              labelKey="accountDetail"
              valueKey="accountNumber"
              (search)="searchManagementCompany($event)"
              [multiple]="false"
              >
            </inm-search-box>
            @if (managementCompanyCtrl.invalid && (managementCompanyCtrl.dirty || managementCompanyCtrl.touched)) {
              <inm-validation-message
                [ngClass]="isEditing ? 'col-md-8  offset-md-4' : ''"
                [control]="managementCompanyCtrl"
                [label]="'.management_company' | staticContent"
                >
              </inm-validation-message>
            }
          } @else {
            <div class="col-md-3 offset-md-4">
              -
            </div>
          }
        </div>
      </inm-input-container>
    </ng-container>
    <ng-container>
      <inm-input-container>
        <div class="row inline-edit-form">
          <div class="inm-subheading inm-mid-blue-text" [ngClass]="isEditing ? 'col-md-4 mt-auto' : ''">
            {{ '.ship_owner' | staticContent }}
            <span class="optional">({{ 'modals.optional' | staticContent }})</span>
          </div>
          @if (!accountDetails || accountDetails.accountGroup !== 'INMA') {
            <inm-search-box
              [ngClass]="isEditing ? 'col-md-8' : ''"
              formControlName="shipOwner"
              [placeholder]="'.ship_owner' | staticContent"
              [results]="shipOwnerList"
              labelKey="accountDetail"
              valueKey="accountNumber"
              (search)="searchShipOwner($event)"
              [multiple]="false"
            ></inm-search-box>
          } @else {
            <div class="col-md-3 offset-md-4">
              -
            </div>
          }
        </div>
      </inm-input-container>
    </ng-container>
    <ng-container>
      <inm-input-container>
        <div class="row inline-edit-form">
          <div class="inm-subheading inm-mid-blue-text dealerCode" [ngClass]="isEditing ? 'col-md-4 mt-auto' : ''">
            {{ '.dealer' | staticContent }}
            @if (accountDetails?.accountGroup === 'INMA') {
              <inm-icon
                class="icon ms-2"
                name="{{ iconNames.Info }}"
                size="small"
                [tooltip]="inmADealerTooltip"
              ></inm-icon>
            }
          </div>
          <inm-search-box
            [ngClass]="isEditing ? 'col-md-8' : ''"
            formControlName="dealerCode"
            [placeholder]="'.dealer' | staticContent"
            [results]="dealerList"
            labelKey="accountDetail"
            valueKey="accountNumber"
            (search)="searchDealer($event)"
            [multiple]="false"
            >
          </inm-search-box>
          @if (dealerCtrl.invalid && (dealerCtrl.dirty || dealerCtrl.touched)) {
            <inm-validation-message
              [ngClass]="isEditing ? 'col-md-8  offset-md-4' : ''"
              [control]="dealerCtrl"
              [label]="'.dealer' | staticContent"
              >
            </inm-validation-message>
          }
        </div>
      </inm-input-container>
    </ng-container>
  </form>
</inm-panel>
@if (!isEditing) {
  <inm-panel-actions class="justify-content-center">
    <button inm-button kind="primary" (click)="next()">
      <span>
        {{ 'buttons.next' | staticContent }}
      </span>
    </button>
  </inm-panel-actions>
}

